/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOfficePayrollProfile.ts          *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/officepayroll/office-payroll-profile";

export class AutogenModelOfficePayrollProfile<RowType extends ModelRow> extends Endpoint<RowType, RowOfficePayrollProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowOfficePayrollProfile extends ModelRow<RowOfficePayrollProfileFields> {
	constructor(values?: Partial<RowOfficePayrollProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowOfficePayrollProfileFields {
	bo_reason_code: string;
	bo_reason_code_exclude: string;
	bonus_code: string;
	bonus_tax_method: string;
	company_id: string;
	currency_type: string;
	cutoff_date: string;
	descr: string;
	division_ids: string;
	frozen_payables: string;
	id: string;
	job_class_codes: string;
	only_payees_activity: string;
	override_frequency: string;
	pay_frequency: string;
	pay_rate_method: string;
	payee_ids: string;
	payee_ids_exclude: string;
	payee_status: string;
	payment_method: string;
	profile_color: string;
	start_date: string;
	terminal_ids: string;
}

